module.exports = __webpack_public_path__ + "static/img/act_text_04.309b361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/act_text_04.png
// module id = ZhoJ
// module chunks = 1